import { login,adminLogin ,logout,getUser} from '@/api/login/login'
import { getToken, setToken,removeToken,getUserName,setUserName,removeUserName } from '@/utils/auth'
import { StaticRouterMap } from '@/router/index'
import router from '@/router'
import bus from '@/layout/components/bus'
const user = {
  namespaced: true,
  state: {
    token: getToken(),
    userName:getUserName(),
    userInfo:window.localStorage.getItem('userInfo'),
    init: false, // 是否完成初始化 // 默认未完成
    RouterList: [], // 动态路由,
    logoutType:''
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, userName) => {
      state.userName = userName
   
    },
    SET_USER_INFO: (state, val) => {
      state.userInfo = val
      window.localStorage.setItem('userInfo',val)
   
    },
    set_router: (state, RouterList) => {
      state.RouterList = RouterList
    },
    set_init: (state, status) => {
      state.init = status
    },
    set_logout_type:(state,val) => {
      state.logoutType = val
    },
    SETINSPECTSCJEMA: (state, data) => {
      state.inspectSchema = data
    },
  },

  actions: {
    //查询条件
    setinspectSchema({ commit }, data) {
      commit('SETINSPECTSCJEMA', data)
    },
    // 登录
    login({ commit }, userNum) {
      const username = userNum.loginName
      console.log(username)
      return new Promise((resolve, reject) => {
        login(username, userNum.password).then(response => {
            console.log(userNum.isEasyPdw)
            console.log(response)
            if((response!= null && response.data.type == 'admin')){
              //判断是都为admin 需要弹框让他用手机号验证码的方式登录 adminMobile: "13565689898"
              userNum.mobile = response.data.adminMobile;
              userNum.lockUser = 99999; //弹出手机号验证码
            } else if(userNum.isEasyPdw != true &&  response.data.lockUser != 1){
              const data = response.data
              setToken(data)
              commit('SET_TOKEN', data)
              userNum.lockUser = null;
              getUser().then(res=>{
                const userName = res.data.name
                const userInfo = res.data
                setUserName(userName)
                commit('SET_USER_INFO', userInfo)
                commit('SET_NAME', userName)
              })
            }
             else if(response!= null && response.data.lockUser == 1){
              //一键解锁
              userNum.lockUser = response.data.lockUser;
              userNum.mobile = response.data.mobile;
            }
            resolve()
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },

    // admin登录
    adminLogin({ commit }, userNum) {
      console.log(userNum)
      return new Promise((resolve, reject) => {
        adminLogin(userNum.adminMobile, userNum.adminCode).then(response => {
            console.log(userNum.isEasyPdw)
            console.log(response)
            if((response!= null)){
              const data = response.data
              setToken(data)
              commit('SET_TOKEN', data)
              getUser().then(res=>{
                const userName = res.data.name
                const userInfo = res.data
                setUserName(userName)
                commit('SET_USER_INFO', userInfo)
                commit('SET_NAME', userName)
              })
            }
            resolve()
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },


    setTokenPage({ commit },token){
      setToken(token)
      commit('SET_TOKEN',token)
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUser().then(res=>{
          const userName = res.data.name
          const userInfo = res.data
          setUserName(userName)
          commit('SET_USER_INFO', userInfo)
          commit('SET_NAME', userName)
        })
      })
    },
    // 动态设置路由 此为设置设置途径
    setRouterList({ commit }, routerList) {
      commit('set_router', StaticRouterMap.concat(routerList)) // 进行路由拼接并存储
    },
    
    // 登出
    LogOut({ commit, state }) {
      console.log('LogOut')
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then((res) => {
            commit('SET_TOKEN', '')
            commit('set_init', false)
            commit('set_router', [])
            commit('SET_NAME', '')
            commit('set_logout_type', res.data)
            removeToken()
            removeUserName()
            window.localStorage.removeItem('userInfo')
            commit('SET_USER_INFO', '')
            resolve()
          }).then(()=>{
            if(state.logoutType == '1'){
              //var url = process.env.VUE_APP_SSO_BASE_API + '/ssoLogout'
              var url = 'http://10.20.128.226/idp/profile/OAUTH2/Redirect/GLO?redirctToUrl=https://cccmb.cnca.cn/login&redirectToLogin=true&entityId=test'
              window.location.href = url
            }
            else
            {
              router.push('login')
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  
    // 前端 登出(测试方法)
    resetToken({ commit }) {
        console.log('sdf')
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('set_init', false)
        commit('set_router', [])
        commit('SET_NAME', '')
        removeToken()
        removeUserName()
        window.localStorage.removeItem('userInfo')
        resolve()
      }).then(()=>{
        location.reload()
      })
    }
  }
}

export default user
